import { useEffect, useState } from "react";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from "react-redux";
import { getOptionsMaster } from "../../../reducers/talentNotification";
import { NO_ANSWER_JOB_CHANGE_SITUATION } from "../../../constants/index";

export const TypeOptions = () => {
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    const {
        optionsMaster,
    } = useSelector((state: any) => state.talentNotification);
    const currentUser = useSelector((state: any) => state.currentUser);
    const { expected_condition } = currentUser.talentInfo;

    useEffect(() => {
        const data = {
          option: 'job_change_situation',
        }
        dispatch(getOptionsMaster(data));
    }, []);

    const questionOptions = optionsMaster
    .filter((option: any) => option.name === 'job_change_situation')
    .flatMap((option: any) => 
        option.option_list
        .filter((subOption: any) => subOption.value != NO_ANSWER_JOB_CHANGE_SITUATION)
        .map((subOption: any) => ({
            name: subOption.label,
            id: subOption.id,
            value: subOption.value,
        }))
    );

    const maskQuestionOptions = [
        {
            value: "actively_considered",
            label: "積極的に転職活動をしている",
        },
        {
            value: "be_considered",
            label: "検討しており情報収集を始めている",
        },
        {
            value: "good_recruitment",
            label: "いい募集があれば話を聞きたい",
        },
        {
            value: "unwilling",
            label: "今すぐの転職は考えていない",
        },
    ];

    const firstQuestionOptions = questionOptions.map((item: any) => ({
        ...item,
        name: maskQuestionOptions.find((option: any) => option.value === item.value)?.label,
    }));

    const noAnswerOption = optionsMaster
    .find((option: any) => option.name === 'job_change_situation')
    ?.option_list.find((subOption: any) => subOption.value === NO_ANSWER_JOB_CHANGE_SITUATION);
    
    const secondQuestionOptions = [
        {
            label: "新規事業に関わりたい",
            value: false,
            name: "new_business",
        },
        {
            label: "給与を上げたい",
            value: false,
            name: "management",
        },
        {
            label: "少人数部門で働きたい",
            value: false,
            name: "small_department",
        },
        {
            label: "社長・役員直属",
            value: false,
            name: "fast_growing_department",
        },
        {
            label: "マネジメントをしたい",
            value: false,
            name: "report_to_executives",
        },
        {
            label: "残業少な目",
            value: false,
            name: "report_to_president",
        },
        {
            label: "未経験からのチャレンジがしたい",
            value: false,
            name: "onsite",
        },
        {
            label: "海外事業・グローバル案件に関わりたい",
            value: false,
            name: "annual_income",
        },
        {
            label: "資格・スキルを活かしたい",
            value: false,
            name: "headquarter_function",
        },
        {
            label: "その他",
            value: false,
            name: "others",
        },
    ];

    const foundLabels: any = [];
    const notFoundLabels: any = [];

    if(expected_condition) {
        const arr_expected_condition = expected_condition.split('|').map((item: any) => item.trim());

        arr_expected_condition.forEach((label: any) => {
            const isFound = secondQuestionOptions.some((option: any) => option.label.includes(label));
            if (isFound) {
                foundLabels.push(label);
            } else {
                notFoundLabels.push(label);
            }
        });
    }

    return {
        firstQuestionOptions,
        secondQuestionOptions,
        noAnswerOption,
        foundLabels,
        notFoundLabels,
    };
}